module.exports = __webpack_public_path__ + "img/任务领取数量.8a7f5c12.png";